import { getFoxitToken, getMSGraphToken } from "../apis/foxit";
import { MS_TEAMS_STORAGE_KEYS } from "../types/storage";
import { getTeamsDataFromUrl } from "../utils/utils";

type FOXIT_TOKEN_IN_TEAMS = {
    token: string;
    enterpriseId: string;
    role: string;
}

export async function getFoxitTokenWithinTeams(): Promise<FOXIT_TOKEN_IN_TEAMS> {
    const token = localStorage.getItem(MS_TEAMS_STORAGE_KEYS.FOXIT_TOKEN);
    if (token) {
        return JSON.parse(token);
    }
    // If user from other region(EU/CA), token might not be saved at current domain.
    // so fetch token by this existed api.
    const { email } = getTeamsDataFromUrl();
    const { data } = await getFoxitToken(email);
    let { foxitToken, enterpriseId, role } = data as any;
    return {
        token: foxitToken,
        enterpriseId,
        role
    };
}

export function deleteFoxitTokenWithTeams() {
    localStorage.removeItem(MS_TEAMS_STORAGE_KEYS.FOXIT_TOKEN);
}

export async function getMSGraphTokenWithinTeams() {
    const token = localStorage.getItem(MS_TEAMS_STORAGE_KEYS.MS_GRAPH_TOKEN);
    if (token) {
        return token;
    }
    const { email } = getTeamsDataFromUrl();
    const { data: { graphToken } } = await getMSGraphToken(email);
    return graphToken;
}
